export default __webpack_public_path__ + "33f0def1cad65d4be50a88d558af880f.png";